export default __webpack_public_path__ + "static/media/users.070b5678.png";